import { useState, useEffect } from "react";
import { Video } from "lucide-react";
import { api } from "@/lib/api";
import { SendVideoCell } from "@/components/SendVideoCell";

const COLS = ["Date", "Source", "Parent", "Child", "Email", "Phone", "Notes", "Deliver"];

export const VideoRequestsTable = ({ token, fmtDate }) => {
  const [rows, setRows] = useState(null);
  const [failed, setFailed] = useState(false);
  const markSent = (row, at, url) => setRows((rs) => rs.map((r) => (r === row ? { ...r, delivered_at: at, video_url: url } : r)));

  useEffect(() => {
    api.get("/admin/video-requests", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setRows(r.data))
      .catch(() => setFailed(true));
  }, [token]);

  if (failed) {
    return (
      <p className="mt-20 font-body text-sm" style={{ color: "#B42318" }} data-testid="admin-video-error">
        Could not load video requests. Please log out and enter your passcode again.
      </p>
    );
  }

  return (
    <section className="mt-20" data-testid="admin-video-requests">
      <p className="overline mb-3" style={{ color: "var(--gold)" }}>Underwater videos</p>
      <h2 className="font-display text-3xl md:text-4xl" style={{ color: "var(--navy)" }}>Video requests</h2>
      <p className="font-body font-light mt-2 mb-8" style={{ color: "var(--muted)" }} data-testid="admin-video-count">
        {rows ? `${rows.length} ${rows.length === 1 ? "request" : "requests"} · $10 per filmed lesson` : "Loading…"}
      </p>
      {rows && rows.length === 0 ? (
        <div className="text-center py-14 rounded-2xl border bg-white" style={{ borderColor: "rgba(212,175,55,0.3)" }} data-testid="admin-video-empty">
          <Video size={28} className="mx-auto mb-3" style={{ color: "var(--gold)" }} />
          <p className="font-body font-light" style={{ color: "var(--muted)" }}>Requests from the Underwater Videos page and lesson bookings will appear here.</p>
        </div>
      ) : (
        <div className="rounded-2xl border overflow-x-auto bg-white" style={{ borderColor: "rgba(212,175,55,0.3)" }}>
          <table className="w-full text-left border-collapse" data-testid="admin-video-table">
            <thead>
              <tr style={{ backgroundColor: "var(--navy)" }}>
                {COLS.map((c) => <th key={c} className="px-5 py-4 font-body text-xs uppercase tracking-wider text-white/90 whitespace-nowrap">{c}</th>)}
              </tr>
            </thead>
            <tbody>
              {rows?.map((r) => (
                <tr key={`${r.source}-${r.email}-${r.created_at}`} className="border-t font-body text-sm" style={{ borderColor: "rgba(11,27,61,0.08)", color: "var(--navy)" }} data-testid="admin-video-row">
                  <td className="px-5 py-4 whitespace-nowrap" style={{ color: "var(--muted)" }}>{fmtDate(r.created_at)}</td>
                  <td className="px-5 py-4 whitespace-nowrap">{r.source}</td>
                  <td className="px-5 py-4">{r.parent_name || "-"}</td>
                  <td className="px-5 py-4">{r.child_name || "-"}</td>
                  <td className="px-5 py-4">{r.email || "-"}</td>
                  <td className="px-5 py-4 whitespace-nowrap">{r.phone || "-"}</td>
                  <td className="px-5 py-4 max-w-xs">{r.notes || "-"}</td>
                  <td className="px-5 py-4"><SendVideoCell row={r} token={token} fmtDate={fmtDate} onSent={markSent} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
